var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.datalist.length)?_c('vBread',{staticClass:"nav-breadcrumb-header"},_vm._l((_vm.datalist),function(item,index){return _c('vBreadItem',_vm._b({key:index},'vBreadItem',item,false),[_vm._v(_vm._s(_vm.$t(item.langKey,{defaultValue:item.title})))])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }